<territories-panel *ngIf="_isVisiblePanelTerritories"></territories-panel>
<territories-edit-panel *ngIf="_isVisiblePanelEditTerritories"></territories-edit-panel>
<territories-details-panel *ngIf="_isVisiblePanelDetailTerritories"></territories-details-panel>